import { VehicleInfoData } from '../../dtos';
const resetVehicleInfo = (state, action) => {
    return Object.assign(new VehicleInfoData(), {
        VehicleSelectionMethod: action.payload.vehicleSelectionMethod,
        Vin: action.payload.vin
    });
};
export default resetVehicleInfo;
//# sourceMappingURL=resetVehicleInfo.js.map